import {
  EDITOR_STORE, EditorStore,
  BRAND_STORE, BrandStore,
  PERSON_STORE, PersonStore, popupSelectorTypes,
  EDITOR_MONITOR_STORE, EditorMonitorStore, ProjectPageStore, PROJECT_PAGE_STORE
} from 'store'

export interface LibraryTabProps {
  [EDITOR_STORE]?: EditorStore;
  [BRAND_STORE]?: BrandStore;
  [PERSON_STORE]?: PersonStore;
  [EDITOR_MONITOR_STORE]?: EditorMonitorStore;
  [PROJECT_PAGE_STORE]?: ProjectPageStore
}

export const itemLabels = {
  actors: 'Actors' as 'Actors',
  directors: 'Directors' as 'Directors',
  producers: 'Producers' as 'Producers'
}

export const addItemsMenuOptions = [
  {
    label: 'Add Product',
    key: popupSelectorTypes.addProduct
  },
  {
    label: 'Add Person',
    key: popupSelectorTypes.addPerson
  }
]

export const filterMenuKeyTypes = {
  usedProducts: 'usedProducts' as 'usedProducts',
  unusedProducts: 'unusedProducts' as 'unusedProducts',
  usedPersons: 'usedPersons' as 'usedPersons',
  unusedPersons: 'unusedPersons' as 'unusedPersons'
}

export const filterMenuOptions = [
  {
    label: 'Used Products',
    key: filterMenuKeyTypes.usedProducts
  },
  {
    label: 'Unused Products',
    key: filterMenuKeyTypes.unusedProducts
  },
  {
    label: 'Used Persons',
    key: filterMenuKeyTypes.usedPersons
  },
  {
    label: 'Unused Persons',
    key: filterMenuKeyTypes.unusedPersons
  }
]
